// Modal style objects for sx prop usage
export const modalStyles = {
  dialogRoot: {},
  actionRoot: {
    justifyContent: "space-between",
    padding: "8px 16px 8px 16px",
    "& .MuiDialogTitle-root": {
      padding: 0,
    },
  },
  contentRoot: {
    margin: "0 0 8px 0",
    padding: "0 16px 8px 16px",
  },
  contentNoPaddingXRoot: {
    margin: "0 0 8px 0",
    padding: "0 0 8px 0",
  },
};
